var modules_17a50390 = {"background":"_w62oc8","dialog":"_uxuho","sheet":"_1sbwket","dialog__content":"_qb8b55","sheet__content":"_1sioi9t","contentLoaded":"_1ktuzjt","dialog__authorizationLink":"_132ie3n","sheet__authorizationLink":"_6ymqde","authorizationLink--withAllOffersLink":"_1uog76h"};
import "../../../assets/4nqDHkCC.css";

export { modules_17a50390 as default };
//# sourceMappingURL=PopupForSpecialOffers.module.scss.js.map
